import { render } from "./TakEawaycoffeef.vue?vue&type=template&id=198f543e"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawaycoffeef.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "198f543e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('198f543e', __exports__)) {
    api.reload('198f543e', __exports__)
  }
  
  module.hot.accept("./TakEawaycoffeef.vue?vue&type=template&id=198f543e", () => {
    api.rerender('198f543e', render)
  })

}


export default __exports__